import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d509393"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "member-card-wrap" }

import { onMounted, onBeforeUnmount, PropType, ref } from 'vue'
import { loadUIkitComponent } from '@/utils/loadComponent'
import { useUserStore } from '@/store/user'
import { useGroupStore } from '@/store/group'

type Vue2Component = {
  $mount(container: HTMLElement): void
  $destroy(): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'memberCard',
  props: {
  item: {
    type: Object as PropType<{
      id: number
      avatar: string
      isExternal: boolean
      sign: string
      nickname: string
      roleId: number
      status: number
      disabled: boolean
      userId: number
      user_name: string
    }>
  }
},
  setup(__props) {

const props = __props


const userStore = useUserStore()
const groupStore = useGroupStore()
const memberCardContainer = ref<HTMLElement | null>(null)
let card: Vue2Component | null = null
const loadCard = async () => {
  const MemberCard = await loadUIkitComponent('@uikit/member-card')
  const { currentAccount } = userStore
  const isCompanyAccount = !!currentAccount?.is_company_account // 是否企业成员
  // 是否使用企业卡片，当前用户和选中成员的companyId和团队所在的companyId一致时
  const useCompanyCard =
    isCompanyAccount &&
    !props.item?.isExternal &&
    currentAccount?.company_id === groupStore.companyId
  const memberId = props.item?.userId
  const memberInfo = useCompanyCard
    ? {
        userid: memberId,
        cid: groupStore.companyId,
        woa: {
          isChat: true,
          link: `woa://woa.wps.cn/chat?chat_type=1&user_id=${memberId}`
        }
      }
    : {
        userid: memberId,
        name: props.item?.nickname
          ? props.item?.nickname
          : props.item?.user_name,
        avatar: props.item?.avatar
      }
  card = MemberCard.default?.create({
    uid: userStore.userId,
    is_company_account: useCompanyCard,
    memberInfo: memberInfo,
    showClose: false,
    includeDefaultContentItems: ['deptName', 'email', 'markname']
  })
  if (memberCardContainer.value) {
    card?.$mount(memberCardContainer.value)
  }
}
onMounted(() => {
  loadCard()
})
onBeforeUnmount(() => {
  card?.$destroy()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "member-card-container",
      ref_key: "memberCardContainer",
      ref: memberCardContainer
    }, null, 512)
  ]))
}
}

})